// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1hbMR","header":"PatientBlock_header__3zwrH","label":"PatientBlock_label__2dpHi","option":"PatientBlock_option__3vdCh"};